export const BG_PRIMARY = 'rgba(245,242,242,1)';
export const BG_SECONDARY = 'rgba(73,80,59,1)';
export const BG_ALTERNATIVE = 'rgba(124,120,97,1)';

export const TEXT_PRIMARY = 'rgba(21,19,19,1)';
export const TEXT_SECONDARY = 'rgba(255,255,255,1)';
export const TEXT_PRIMARY_LIGHT = 'rgba(255,255,255,1)';

export const BTN_NAVIGATION_COLOR = '#7f8475';

// Opacity layer for left content (Desktop view)
export const BG_SECONDARY_TRANSPARENT = '';
